@if (isPanelOpen) {
  <div
    [style.--header-height]="headerHeight$() + 'px'"
    class="fulfill-side-panel-overlay"
    (click)="togglePanel()"></div>
}
<div class="fulfill-side-panel" [ngClass]="{ open: isPanelOpen }">
  <div class="fulfill-side-panel__toggle-btn-wrapper">
    <button class="fulfill-side-panel__toggle-btn" (click)="togglePanel()">
      <pdq-icon [icon]="isPanelOpen ? 'side_right_arrow' : 'side_left_arrow'"></pdq-icon>
    </button>
  </div>

  @if (isPanelOpen) {
    <div class="fulfill-side-panel__main">
      @if (panelState === 'scan') {
        <fulfill-side-panel-scan label="Scan any batch or label"></fulfill-side-panel-scan>
      }
      @if (panelState === 'order') {
        @if (isLoadedActiveOrder) {
          <fulfill-side-panel-order [order]="activeOrder"> </fulfill-side-panel-order>
        } @else {
          <skeleton-fulfill-order class="skeleton-placeholder"></skeleton-fulfill-order>
        }
      }
      @if (panelState === 'batch') {
        @if (isLoadedActiveBatch) {
          <fulfill-side-panel-batch [batch]="activeBatch"> </fulfill-side-panel-batch>
        } @else {
          <skeleton-fulfill-batch class="skeleton-placeholder"></skeleton-fulfill-batch>
        }
      }
    </div>
  }
</div>
